export const state = () => ({
  currentPhone: '',
  isAdvContent: false,
});

export const mutations = {
  setCurrentPhone(state, phone) {
    state.currentPhone = phone;
  },

  setAdvContent(state, check) {
    state.isAdvContent = check;
  },
};
